import './main.scss';
import React, {useState} from 'react';
import {Navigate, useNavigate} from 'react-router-dom';
import Header from '../../../organisms/header/header.js';
import decodeToken from '../../../../utils/decode-token';
import {useTranslation} from 'react-i18next';

import Footer from "../../../organisms/footer/footer";

import ExperienceCatalog from "../../../organisms/common/experiences/catalog";


const RetailerExperienceCatalog = () => {
  window.scroll(0, 0);

  const {t} = useTranslation();

  const token = sessionStorage.getItem('token') || null;
  const role = decodeToken(token).role;
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('experiences');

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    if (tab === 'nominated') {
      navigate('/retailer/main/nominated');
    } else if (tab === 'active') {
      navigate('/retailer/main/active');
    } else if (tab === 'exited') {
      navigate('/retailer/main/exited');
    }
  };

  return (
    <>
      {token && (role === 'retailer' || role === 'retailerGM') ? (
        <div className="App">
          <Header/>
          <main className="landing">
            <div className="tabs">
              <ul>
                <li className={activeTab === 'nominated' ? 'active' : ''}>
                  <span onClick={() => handleTabClick('nominated')}>{t('retailer-main-tabs-tab1')}</span>
                </li>
                <li className={activeTab === 'active' ? 'active' : ''}>
                  <span onClick={() => handleTabClick('active')}>{t('retailer-main-tabs-tab2')}</span>
                </li>
                <li className={activeTab === 'exited' ? 'active' : ''}>
                  <span onClick={() => handleTabClick('exited')}>{t('common-exited')}</span>
                </li>
                <li className={`opossed ${activeTab === 'experiences' ? 'active' : ''}`}>
                  <span onClick={() => handleTabClick('experiences')}>{t('common-experiences')}</span>
                </li>
              </ul>
            </div>
            <section className="gallery catalog">
              <div className="inner">
                <ExperienceCatalog></ExperienceCatalog>
              </div>
            </section>
          </main>
          <Footer/>
        </div>
      ) : (
        <Navigate to="/login"/>
      )}

    </>
  );
};

export default RetailerExperienceCatalog;
